"use client";

import type { ReactNode } from "react";

interface Props {
  children: ReactNode;
}

export default function PlanBoard({ children }: Props) {
  return (
    <section className="min-w-0 flex-1" data-testid="plan-board-shell">
      <h2 className="sr-only">Plan</h2>
      {children}
    </section>
  );
}
